import { action, makeObservable, observable } from 'mobx';

export class VersionsStore {
  @observable isOpened: boolean = false;
  @observable frontendV: string = import.meta.env.COMMIT_TAG
    ? import.meta.env.COMMIT_TAG
    : `commit/${import.meta.env.COMMIT_SHORT_SHA}`;
  @observable backendV: string = '';
  @observable cacheV: string = '';
  @observable orchestratorV: string = '';

  constructor() {
    makeObservable(this);
  }

  @action.bound
  setIsOpened(value: boolean): void {
    this.isOpened = value;
  }
}
